@if (isDialogVisible()) {
<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{welcomeSurveyDialogData.title}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <div class="dialog-content-padding">
        <h4 class="xlg-text">{{welcomeSurveyDialogData.subheading}}</h4>
        <span class="md-text top-padding" [innerHTML]=welcomeSurveyDialogData.instructions></span>
    </div>

    <mat-dialog-actions class="uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-primary-button" (click)="close(true)" (keyup.enter)="close(true)" tabindex="0">{{welcomeSurveyDialogData.confirmButtonLabel}}</button>
    </mat-dialog-actions>
</section>
}